import React from 'react';
import { Button } from '@material-ui/core';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppDatePicker,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import * as CentralBankPaymentSelector from '../../../../redux/reducers/payment_central_bank_reducer/selectors';
import NavigationConfig from 'navigation/config';
import { useHistory } from 'react-router';
import * as DateUtils from 'utils/dates';

interface FormFields {
  statusCode: string | null;
  account: string | null;
  dateFrom: Date | null;
  dateTo: Date | null;
}

interface IProps {
  statusCode: string | null;
  account: string | null;
  dateFrom: Date | null;
  dateTo: Date | null;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();
  const defaultValues = {
    statusCode: props.statusCode ? props.statusCode : null,
    account: props.account ? props.account : null,
    dateFrom: props.dateFrom ? props.dateFrom : null,
    dateTo: props.dateTo ? props.dateTo : null,
  };
  const { control, errors, handleSubmit } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.statusCode)
      query.push({
        key: 'statusCode',
        value: data.statusCode,
      });
    if (data.account)
      query.push({
        key: 'account',
        value: data.account,
      });
    if (data.dateFrom) {
      const date_from = DateUtils.DateInQueryFormat(data.dateFrom);
      query.push({
        key: 'dateFrom',
        value: date_from,
      });
    }
    if (data.dateTo) {
      const date_to = DateUtils.DateInQueryFormat(data.dateTo);
      query.push({
        key: 'dateTo',
        value: date_to,
      });
    }
    let queryString = '';
    console.log(query);
    query.map((query, index) => {
      if (index == 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.paymentCentralBankPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.paymentCentralBankPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        elements={
          [
            {
              element: renderAccounts(errors, control),
              size: 3,
              id: 'account',
            },
            {
              element: renderStatus(errors, control),
              size: 2,
              id: 'statusCode',
            },
            {
              element: renderDateFrom(errors, control),
              size: 2,
              id: 'dateFrom',
            },
            {
              element: renderDateTo(errors, control),
              size: 2,
              id: 'dateTo',
            },
            {
              element: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginRight: '0.25rem',
                    }}
                  >
                    <TranslatedText textMap={Translations.search} />
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginLeft: '0.25rem',
                    }}
                    onClick={clearFilter}
                  >
                    <TranslatedText textMap={Translations.clear} />
                  </Button>
                </div>
              ),
              size: 3,
              id: 'search',
            },
          ] as any
        }
      />
    </form>
  );
};

const renderAccounts = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const select_options =
    CentralBankPaymentSelector.useGetCentralBankPaymentAccounts();

  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.account} />}
      id="account"
      name="account"
      error={'account' in errors}
      control={control}
      rules={{}}
      options={
        select_options && select_options.data
          ? select_options.data.map((account, index) => {
              return {
                id: `${account.pcb_account}`,
                label: account.pcb_account,
              };
            })
          : []
      }
      helperText={errors.account && errors.account.message}
    />
  );
};

const renderStatus = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const select_options =
    CentralBankPaymentSelector.useGetCentralBankPaymentStatusCodes();
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.statusCode} />}
      id="statusCode"
      name="statusCode"
      error={'statusCode' in errors}
      control={control}
      rules={{}}
      options={
        select_options && select_options.data
          ? select_options.data.map((x) => {
              return {
                id: `${x.statusCode}`,
                label: x.statusDesc,
              };
            })
          : []
      }
      helperText={errors.statusCode && errors.statusCode.message}
    />
  );
};

const renderDateFrom = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppDatePicker
      fullWidth
      id="dateFrom"
      label={<TranslatedText textMap={Translations.dateFrom} />}
      error={'dateFrom' in errors}
      name="dateFrom"
      control={control}
      rules={{}}
      autoOk
    />
  );
};

const renderDateTo = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppDatePicker
      fullWidth
      id="dateTo"
      label={<TranslatedText textMap={Translations.dateTo} />}
      error={'dateTo' in errors}
      name="dateTo"
      control={control}
      rules={{}}
      autoOk
    />
  );
};

export default FilterForm;
